import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { getDefaultTooltipFormatterWithTotal, mapIdsToLabels } from './chartUtils';

const OrganizationInfluencerMessageTypeByInfluencerChart = ({ data, influencerLabelMap, pending }) => {
  const { categories, series } = useMemo(() => {
    const categories = mapIdsToLabels(data?.influencerIds, influencerLabelMap);

    return {
      categories,
      series: [
        { name: 'Main Flow', data: data?.mainFlowEarnings || [] },
        { name: 'Manual', data: data?.manualEarnings || [] },
        { name: 'Mass DM', data: data?.massDmEarnings || [] },
      ],
    };
  }, [data, influencerLabelMap]);
  const tooltipFormatter = useMemo(() => getDefaultTooltipFormatterWithTotal('currency'), []);

  return (
    <OrganizationAnalyticsBarChart
      title="Message Type Earnings By Creator"
      subtitle="Compare how each creator earns across message types."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more creators to compare message type earnings."
      stacked
      tooltipFormatter={tooltipFormatter}
    />
  );
};

export default OrganizationInfluencerMessageTypeByInfluencerChart;
